module.exports = __webpack_public_path__ + "img/006.93d112f3.png";